import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import { FAQS } from "../content";

/**
 * Premium, minimal FAQ accordion.
 * Content is also injected as FAQPage JSON-LD (handled by the page using usePageMeta).
 */
export default function FAQSection({ testid = "faq-section" }) {
  const [open, setOpen] = useState(0);

  return (
    <section
      data-testid={testid}
      className="bg-[#FAF5EC] border-t border-[#6E1F2C]/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-4">
            <p className="eyebrow mb-5">Common Questions</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[#1C110C]">
              Frequently <em className="text-[#6E1F2C] not-italic">asked</em>.
            </h2>
            <p className="mt-6 text-[#3E2A22] leading-relaxed text-base">
              Quick answers about our services, locations, and capabilities. Have something
              specific in mind?{" "}
              <a
                href="/contact"
                className="text-[#6E1F2C] underline underline-offset-4 hover:text-[#56151F]"
                data-testid="faq-contact-link"
              >
                Talk to our team
              </a>
              .
            </p>
            <div className="mt-10 w-16 h-px bg-[#B8904E]" />
          </div>

          <div className="lg:col-span-8">
            <div className="border-t border-[#6E1F2C]/15">
              {FAQS.map((item, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={i}
                    className="border-b border-[#6E1F2C]/15"
                    data-testid={`faq-item-${i}`}
                  >
                    <button
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      data-testid={`faq-toggle-${i}`}
                      aria-expanded={isOpen}
                      className="w-full flex items-start justify-between gap-6 py-6 md:py-8 text-left group"
                    >
                      <h3 className="font-serif-display text-xl md:text-2xl text-[#1C110C] leading-snug pr-4">
                        {item.q}
                      </h3>
                      <span className="shrink-0 mt-1 text-[#6E1F2C] group-hover:text-[#56151F] transition-colors">
                        {isOpen ? (
                          <Minus size={22} strokeWidth={1.6} />
                        ) : (
                          <Plus size={22} strokeWidth={1.6} />
                        )}
                      </span>
                    </button>
                    {isOpen && (
                      <div
                        data-testid={`faq-answer-${i}`}
                        className="pb-7 md:pb-9 pr-12 text-[#3E2A22] leading-[1.8] text-[15px] md:text-base"
                      >
                        {item.a}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
